import { Role } from '../types/user';

export const ROLE_HIERARCHY = {
  [Role.SUPER_ADMIN]: 4,
  [Role.VENDOR]: 3,
  [Role.VENDOR_STAFF]: 2,
  [Role.CUSTOMER]: 1,
};

export const ROLE_LABELS = {
  [Role.SUPER_ADMIN]: 'Super Admin',
  [Role.VENDOR]: 'Vendor',
  [Role.VENDOR_STAFF]: 'Vendor Staff',
  [Role.CUSTOMER]: 'Customer',
};

export function hasHigherRole(userRole: Role, requiredRole: Role): boolean {
  return ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[requiredRole];
}
